import React from 'react';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import BoxesPng from '../images/boxes.png';
import BoxesWebp from '../images/boxes.webp';

import { DiscountBox } from './DiscountBox';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

export const OverviewTab = React.memo(
  ({ discountCode, isEntitled }: { discountCode?: string; isEntitled: boolean }) => {
    const { t } = useIntl();
    return (
      <div style={styles.overviewTab}>
        <div className='font-heading-xsmall-regular padding-bottom-l'>
          <Msg
            id='benefits.relocationBox.modal.overview.overviewParagraph1'
            defaultMessage='Umzugskisten von Turtlebox - die clevere Alternative zu Umzugskartons'
          />
        </div>
        <div className='padding-bottom-l'>
          <Msg
            id='benefits.relocationBox.modal.overview.overviewParagraph2'
            defaultMessage='Die umweltfreundlichen Umzugsboxen zur Miete:'
          />
        </div>
        <ul className='list-check list-spacing-s'>
          <li>
            <Msg
              id='benefits.relocationBox.modal.overview.checkmarkList.item1'
              defaultMessage='Stabil, stapelbar und wetterfest'
            />
          </li>
          <li>
            <Msg
              id='benefits.relocationBox.modal.overview.checkmarkList.item2'
              defaultMessage='Aus 100% recycelbarem Kunststoff'
            />
          </li>
          <li>
            <Msg
              id='benefits.relocationBox.modal.overview.checkmarkList.item3'
              defaultMessage='Praktischer Liefer- und Abholservice'
            />
          </li>
          <li>
            <Msg
              id='benefits.relocationBox.modal.overview.checkmarkList.item4'
              defaultMessage='5% Rabatt, Mit MieterPlus 20% Rabatt.'
              values={{ BuyerPlusLogo: <PlusBadge variant='rent' /> }}
            />
          </li>
        </ul>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <ImageSource
            image={BoxesPng}
            imageWebp={BoxesWebp}
            imageMobile={BoxesPng}
            imageMobileWebp={BoxesWebp}
            imageAlt={t({
              id: 'benefits.relocationBox.modal.overview.image',
              defaultMessage: 'Relocation boxes',
            })}
          />
        </div>
        <DiscountBox isEntitled={isEntitled} discountCode={discountCode} />
      </div>
    );
  },
);
